export const DefaultKickstartVariables = 5;
//# sourceMappingURL=consts.js.map